import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import TopicBanner from './TopicBanner'
import TopicSummary from './TopicSummary'
import FixedNavigationModel from './FixedNavigationModel'
import StyleTwoCombinClass from '../style-two/StyleTwoCombinClass'
import StyleTwoSelfStudyCurriculum from '../style-two/StyleTwoSelfStudyCurriculum'
import { selfStudyImgs } from '../../images/topicImg'
import { SummaryPreschoolData, PreschoolCurriculumData, PreschoolCombinClassData } from '../../utils/tools/publicParams'

function PreschoolEducation(){
  const ColorData = {
    color: 'rgba(39, 89, 210, 1)'
  }
  const navigationModelData = [
    { id: 1, title: '组合班级', href: '#combinClass' },
    { id: 2, title: '课程体系', href: '#curriculum' }
  ]

  const onMeiQiaCustomer = () => {
    window._MEIQIA('showPanel');
  }

  return (
    <div className="topic-preschool-education">
      {/* 专题Banner */}
      <TopicBanner url={selfStudyImgs.xq_Banner_bg} />
      {/* 汇总统计行 */}
      <TopicSummary SummaryData={SummaryPreschoolData} ContentColor={ColorData.color} />
      {/* 组合班级 版本二 */}
      <StyleTwoCombinClass itemsData={PreschoolCombinClassData} ContentColor={ColorData.color} onMeiQiaCustomer={onMeiQiaCustomer} />
      {/* 课程体系 版本二 - 自考 */}
      <StyleTwoSelfStudyCurriculum itemsData={PreschoolCurriculumData} ContentColor={ColorData.color} />

      <FixedNavigationModel itemsData={navigationModelData} />
    </div>
  );
}
PreschoolEducation.propTypes = {
  topic: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
}
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreschoolEducation);



// WEBPACK FOOTER //
// ./src/features/topic/PreschoolEducation.js